import React from 'react'

import Search from '../search/Search'
import HeaderActions from './HeaderActions'
import FulesPriceTable from '../../fuel-stations/fuel-prices/FuelsPriceTable'
import './header-view.scss'

const HeaderView = ({
  title,
  pricesOwnStation,
  searchOptions,
  handlerHeaderActions,
}) => {
  return (
    <div className="header-view">
      <h2 className="title__container"> {title} </h2>
      {pricesOwnStation && (
        <div className="btn-container">
          <FulesPriceTable prices={pricesOwnStation} />
        </div>
      )}
      {!pricesOwnStation && (searchOptions || handlerHeaderActions) && (
        <div className="btn-container">
          {searchOptions && (
            <div className="search-area">
              <Search {...searchOptions} />
            </div>
          )}
          {handlerHeaderActions && <HeaderActions {...handlerHeaderActions} />}
        </div>
      )}
    </div>
  )
}

export default HeaderView
